import { render, staticRenderFns } from "./branches.vue?vue&type=template&id=971c81d2&scoped=true&"
import script from "./branches.vue?vue&type=script&lang=js&"
export * from "./branches.vue?vue&type=script&lang=js&"
import style0 from "./branches.vue?vue&type=style&index=0&id=971c81d2&lang=scss&scoped=true&"
import style1 from "./branches.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "971c81d2",
  null
  
)

export default component.exports